import React from "react";

interface DonationContentProps {
  content: string;
}

export function DonationContent({ content }: DonationContentProps) {
  return (
    <div className="prose prose-slate max-w-none">
      {content.split('\n\n').map((paragraph, index) => {
        if (paragraph.startsWith('### ')) {
          return (
            <h2 key={index} className="text-2xl font-bold mb-4 mt-8 first:mt-0">
              {paragraph.replace('### ', '')}
            </h2>
          );
        }
        if (paragraph.startsWith('---')) {
          return <hr key={index} className="my-8" />;
        }
        return (
          <p key={index} className="mb-4 text-app-text-primary text-base leading-relaxed">
            {paragraph}
          </p>
        );
      })}
    </div>
  );
}